import { storageService } from './storage.service'

export function calculateTokenExpiry(expiresInSeconds: string | number): number {
  const seconds = typeof expiresInSeconds === 'string' ? parseInt(expiresInSeconds, 10) : expiresInSeconds
  return Date.now() + seconds * 1000
}

export function isTokenValid(): boolean {
  const expiresIn = storageService.getTokenExpiry()
  if (!expiresIn) return false

  return parseInt(expiresIn, 10) > Date.now()
}
